import BaseNotification from '#BASE/components/notification/notification.base.component';
import signalr from 'BASE/common/signalrAdapter';

export default {
    mixins: [
        BaseNotification,
    ],   
    created() {
        signalr.addWorkOnConnected(() => {
            signalr.betAwardNotifyClient.betAwardNotify.addHandler(result => this.add(result));
        });
    }
};